// Unit.js
// Component for Unit entry

// Imports
import React from 'react';
import { Button, ControlGroup, InputGroup } from '@blueprintjs/core';
import PropTypes from 'prop-types';

// Component Class
// Shows Unit list
class Unit extends React.Component {
  // Constructor
  constructor(props) {
    super(props);
    this.state = {
      unit: this.props.unit.unit,
      price: this.props.unit.price.toFixed(2),
      validUnit: true,
      validPrice: true,
    }
  }

  // Called when button next to unit is called
  onButtonClicked = () => {
    if (this.props.id === 0)
      this.props.add();
    else
      this.props.remove(this.props.id);
  };

  // Called after name field changes
  onUnitChanged = (event) => {
    var value = event.target.value.trim();
    var valid = true;
    if (value.trim() !== "")
      this.props.rename(this.props.id, value.trim());
    else
      valid = false;
    this.setState({unit: event.target.value, validUnit: valid});
  };

  // Called after user finishes editing name field
  onUnitBlur = (event) => {
    if (this.state.unit.trim() === "") {
      var name = this.props.unit.unit;
      this.setState({unit: name, validUnit: true});
      this.props.rename(this.props.id, name);
    }
  }
  
  // Called after price field changes
  onPriceChanged = (event) => {
    var value = Number.parseFloat(event.target.value);
    var valid = true;
    if (!Number.isNaN(value) && value > 0)
      this.props.setPrice(this.props.id, value);
    else
      valid = false;
    this.setState({price: event.target.value, validPrice: valid});
  };

  // Called after user finishes editing price field
  onPriceBlur = (event) => {
    var value = Number.parseFloat(this.state.price);
    if (Number.isNaN(value) || value <= 0)
      value = this.props.unit.price;
    this.setState({price: value.toFixed(2), validPrice: true});
  }

  // Renders Component
  render() {
    var icon = this.props.id === 0 ? "add" : "remove";
    return (
      <ControlGroup fill>
        <InputGroup
          intent={this.state.validUnit ? "":"danger"}
          placeholder="Unidade"
          value={this.state.unit}
          leftIcon="box"
          onChange={this.onUnitChanged}
          onBlur={this.onUnitBlur}
        />
        <InputGroup
          intent={this.state.validPrice ? "":"danger"}
          placeholder="Preço"
          value={this.state.price}
          leftIcon="dollar"
          onChange={this.onPriceChanged}
          onBlur={this.onPriceBlur}
        />
        <Button icon={icon} onClick={this.onButtonClicked} />
      </ControlGroup>
    );
  }
}

// Required Properties
Unit.propTypes = {
  id: PropTypes.number.isRequired,
  unit: PropTypes.object.isRequired,
  add: PropTypes.func.isRequired,
  rename: PropTypes.func.isRequired,
  remove: PropTypes.func.isRequired,
  setPrice: PropTypes.func.isRequired,
}

// Exports
export default Unit;


// WEBPACK FOOTER //
// ./src/components/ProductView/Unit.js